module.exports = __webpack_public_path__ + "static/img/img_culture_f.e3a4a2e7.png";